(() => {
  'use strict';
  function mount() {
    document.querySelectorAll('[data-pdp-subscription]:not([data-mounted])').forEach(root => {
      if (root.closest('.product-pop-up')) return;
      const section = root.closest('.shopify-section');
      const info = section?.querySelector('.product-details > .container > .product-info > .product-details--info');
      if (!info) return;
      let product;
      try { product = JSON.parse(root.querySelector('[data-pdp-subscription-data]').textContent); }
      catch (_) { return; }
      root.dataset.mounted = 'true';
      const price = info.querySelector(':scope > .price');
      info.append(root);
      info.querySelectorAll(':scope > a.btn[href="/collections/shop-now"]').forEach(link => { link.hidden = true; link.style.display = 'none'; });
      const legacyButtons = section.querySelector('.product-details > .container > .addtocart-box');
      if (legacyButtons) { legacyButtons.hidden = true; legacyButtons.style.display = 'none'; }
      root.hidden = false;
      const form = root.querySelector('form');
      const select = form.querySelector('[data-pdp-frequency]');
      const dropdown = form.querySelector('[data-pdp-frequency-dropdown]');
      const display = form.querySelector('[data-pdp-frequency-display]');
      const options = form.querySelector('[data-pdp-frequency-options]');
      if (!select || !dropdown || !display || !options) return;
      const items = Array.from(options.querySelectorAll('[data-pdp-plan-id]'));
      let highlighted = -1;
      const button = form.querySelector('button');
      const status = form.querySelector('[role="status"]');
      const planFor = id => product.plans.find(plan => String(plan.id) === String(id));
      function updatePrice() {
        const plan = planFor(select.value);
        const sale = price?.querySelector('.price--sale');
        if (sale && plan) sale.textContent = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(plan.price / 100);
        const selected = items.find(item => item.dataset.pdpPlanId === select.value);
        display.value = selected?.textContent.trim() || 'Subscription unavailable';
        items.forEach(item => item.setAttribute('aria-selected', String(item === selected)));
      }
      function highlight(index) {
        highlighted = index;
        items.forEach((item, i) => item.toggleAttribute('data-highlighted', i === index));
        if (items[index]) display.setAttribute('aria-activedescendant', items[index].id);
      }
      function setOpen(open) {
        open = open && !display.disabled && items.length > 0;
        options.hidden = !open;
        options.inert = !open;
        dropdown.classList.toggle('active', open);
        display.setAttribute('aria-expanded', String(open));
        if (open) highlight(Math.max(0, items.findIndex(item => item.dataset.pdpPlanId === select.value)));
        else {
          display.removeAttribute('aria-activedescendant');
          items.forEach(item => item.removeAttribute('data-highlighted'));
        }
      }
      function choose(item) {
        select.value = item.dataset.pdpPlanId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setOpen(false);
        display.focus();
      }
      function setFrequencyDisabled(disabled) {
        select.disabled = disabled;
        display.disabled = disabled;
        if (disabled) setOpen(false);
      }
      root.querySelector('[data-pdp-frequency-toggle]').addEventListener('click', () => {
        if (display.disabled) return;
        display.focus();
        setOpen(options.hidden);
      });
      items.forEach(item => item.addEventListener('click', () => {
        if (!display.disabled) choose(item);
      }));
      options.addEventListener('pointerdown', event => event.preventDefault());
      display.addEventListener('keydown', event => {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const wasClosed = options.hidden;
          if (wasClosed) setOpen(true);
          let index = highlighted;
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = items.length - 1;
          else if (!wasClosed) index += event.key === 'ArrowDown' ? 1 : -1;
          highlight(Math.max(0, Math.min(items.length - 1, index)));
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (options.hidden) setOpen(true);
          else if (items[highlighted]) choose(items[highlighted]);
        } else if (event.key === 'Escape' || event.key === 'Tab') {
          if (event.key === 'Escape') event.preventDefault();
          setOpen(false);
        }
      });
      document.addEventListener('pointerdown', event => { if (!dropdown.contains(event.target)) setOpen(false); });
      dropdown.addEventListener('focusout', event => { if (!dropdown.contains(event.relatedTarget)) setOpen(false); });
      select.addEventListener('change', updatePrice);
      updatePrice();
      let pending = false;
      window.addEventListener('pageshow', event => {
        if (!event.persisted || !product.productAvailable || !planFor(select.value)) return;
        pending = false; button.disabled = false; setFrequencyDisabled(false);
        button.removeAttribute('aria-busy'); button.textContent = 'Checkout';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || button.disabled) return;
        const plan = planFor(select.value);
        if (!product.productAvailable || !plan) return;
        pending = true; button.disabled = true; setFrequencyDisabled(true);
        button.setAttribute('aria-busy', 'true'); button.textContent = 'Checking out…'; status.hidden = true;
        const cartRoot = product.rootUrl.endsWith('/') ? product.rootUrl : product.rootUrl + '/';
        let checkoutFrame, requestFetch;
        async function cartRequest(path, body) {
          const url = new URL(cartRoot + path, window.location.origin);
          if (!body) url.searchParams.set('_pdp_checkout', String(Date.now()));
          const response = await requestFetch(url.href, {
            method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
            ...(body ? { body: JSON.stringify(body) } : {}), signal: AbortSignal.timeout(20000)
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw Error(result.description || 'We couldn’t start checkout. Please try again.');
          return result;
        }
        let redirecting = false;
        try {
          // Appstle wraps the parent window's fetch and can replace selling_plan
          // with its own hidden widget selection. Use a clean same-origin realm
          // only for this explicit direct-checkout flow, keeping cookies/CORS intact.
          checkoutFrame = document.createElement('iframe');
          checkoutFrame.hidden = true; checkoutFrame.style.display = 'none';
          checkoutFrame.setAttribute('aria-hidden', 'true');
          checkoutFrame.title = 'Subscription checkout request';
          document.body.append(checkoutFrame);
          requestFetch = checkoutFrame.contentWindow.fetch.bind(checkoutFrame.contentWindow);
          // This direct checkout deliberately replaces only Shopify's real cart.
          // The existing custom cart in localStorage is never read or changed.
          await cartRequest('cart/clear.js', {});
          await cartRequest('cart/add.js', { items: [{ id: Number(product.variantId), quantity: 1, selling_plan: Number(plan.id) }] });
          const cart = await cartRequest('cart.js');
          const line = cart.items?.[0];
          if (cart.items?.length !== 1 || cart.item_count !== 1 || line.quantity !== 1 ||
              String(line.variant_id) !== String(product.variantId) ||
              String(line.selling_plan_allocation?.selling_plan?.id) !== String(plan.id)) {
            throw Error('We couldn’t confirm your subscription checkout. Please try again.');
          }
          window.location.assign(cartRoot + 'checkout');
          redirecting = true;
        } catch (error) {
          status.textContent = error.message || 'We couldn’t start checkout. Please try again.';
          status.hidden = false;
        } finally {
          checkoutFrame?.remove();
          if (!redirecting) {
            pending = false; button.disabled = false; setFrequencyDisabled(false);
            button.removeAttribute('aria-busy'); button.textContent = 'Checkout';
          }
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
